import { InputCheckbox } from '@creditornot/cb-checkbox';
import { colors } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import styled, { css } from 'styled-components';

type Props = {
  className?: string;
  onToggle: () => void;
  disabled?: boolean;
  selectionStatus: 'selected' | 'partially-selected' | 'not-selected';
};

const Background = styled.div<{ selected: boolean }>`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 44px;
  height: 44px;
  background: ${({ selected }) =>
    selected ? colors.wolt24 : cssThemedValue({ light: colors.pepper12, dark: colors.salt12 })};
  transform: scale(0);
  border-radius: 50%;
  transition: transform 96ms ease-in;
`;

const Root = styled.div<{ disabled: boolean }>`
  padding: 16px;
  margin-inline-start: 8px;
  position: relative;
  cursor: pointer;
  border-radius: 50%;

  ${({ disabled }) =>
    disabled
      ? css`
          .wideAreaCheckbox {
            cursor: not-allowed;
          }
        `
      : css`
          &:hover > ${Background} {
            transform: scale(1);
          }

          .wideAreaCheckbox {
            cursor: pointer;
          }
        `}
`;

const WideAreaCheckbox = ({ className, onToggle, disabled, selectionStatus }: Props) => {
  return (
    <Root
      aria-label="wide-area-checkbox-root-div"
      className={className}
      disabled={!!disabled}
      onClick={e => {
        e.stopPropagation();
        if (!disabled) {
          onToggle();
        }
      }}
    >
      <Background aria-label="wide-area-checkbox-background-div" selected={selectionStatus === 'selected'} />
      <InputCheckbox
        aria-label="wide-area-checkbox-input"
        checked={selectionStatus === 'selected'}
        disabled={!!disabled}
        inputClassName="wideAreaCheckbox"
        partiallyChecked={selectionStatus === 'partially-selected'}
        readOnly
      />
    </Root>
  );
};

export default React.memo(WideAreaCheckbox);
